/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsElectrics: {
  name: 'electrics';
  data: string;
} = {
  name: 'electrics',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 1a.5.5 0 0 0-1 0v2.5H6A3.5 3.5 0 0 0 2.5 7v4.5H1a.5.5 0 0 0 0 1h3.5V15a.5.5 0 0 0 1 0v-2.5h5V15a.5.5 0 0 0 1 0v-2.5H15a.5.5 0 0 0 0-1h-1.5V7A3.5 3.5 0 0 0 10 3.5H8.5V1ZM11 11.5h1.5V7A2.5 2.5 0 0 0 10 4.5H6A2.5 2.5 0 0 0 3.5 7v4.5H11ZM5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
